.center_div{margin-top:10px;margin-left:50px;width:70%}.invalid-feedback{color:#f44336}.linkAriadne{font-size:18px;float:right;color:#000}.linkAriadne:hover{color:red}.imgAriadne{height:60px!important}
/*# sourceMappingURL=signup.component-4ZBBB4C5.css.map */
